/* Dollar Sign is part of the message, with a variable amount */ 
/* eslint-disable no-template-curly-in-string */
import { defineMessages } from 'react-intl';

export default defineMessages({
  noItemsInCartMessaging: {
    id: 'PromoBannerTracker.noItemsInCartMessaging',
    defaultMessage: 'Save up to ${totalSavingsAmount}',
  },
  currentQualifiedAmountMessaging: {
    id: 'PromoBannerTracker.currentQualifiedAmountMessaging',
    defaultMessage: 'Spend ${spendingAmount} more to save ${savingsAmount}',
  },
  fullyQualifiedAmountMessaging: {
    id: 'PromoBannerTracker.fullyQualifiedAmountMessaging',
    defaultMessage: 'Enjoy ${finalSavings} off your entire order!',
  },
  noItemsPDPMessaging: {
    id: 'PromoBannerTracker.noItemsPDPMessaging',
    defaultMessage: 'Add items to your cart, to save up to ${savingsAmount} on your entire order.',
  },
  almostQualifiedAmountCartMessaging: {
    id: 'PromoBannerTracker.almostQualifiedAmountCartMessaging',
    defaultMessage: 'Spend ${remainingAmount} more to save ${currentTierDiscount}.',
  },
  currentQualifiedAmountPDPMessaging: {
    id: 'PromoBannerTracker.currentQualifiedAmountPDPMessaging',
    defaultMessage: 'You’re saving ${currentSavings}. Add more to save ${savingsAmount} on your entire order.',
  },
  currentQualifiedAmountCartMessaging: {
    id: 'PromoBannerTracker.currentQualifiedAmountCartMessaging',
    defaultMessage: 'You’re saving ${currentSavings}. Spend ${remainingAmount} more to save ${savingsAmount}.',
  },
  currentQualifiedAmountModalMessaging: {
    id: 'PromoBannerTracker.currentQualifiedAmountModalMessaging',
    defaultMessage: 'You’re saving ${currentSavings}. Spend ${remainingAmount} more to save ${savingsAmount} on your entire order.',
  },
  fullyQualifiedAmountPDPMessaging: {
    id: 'PromoBannerTracker.fullyQualifiedAmountPDPMessaging',
    defaultMessage: 'Congrats, you’re saving ${finalSavings} on your entire order!',
  },
  detailsLinkText: {
    id: 'PromoBannerTracker.detailsLinkText',
    defaultMessage: 'Details',
  },
  freeGiftHeadlineInCart: {
    id: 'PromoBannerTracker.freeGiftHeadlineInCart',
    defaultMessage: 'FREE GIFT WITH PURCHASE',
  },
  congratsFreeGiftHeadlineInCart: {
    id: 'PromoBannerTracker.congratsFreeGiftHeadlineInCart',
    defaultMessage: 'CONGRATS! YOU\'VE EARNED A FREE GIFT',
  },
  noItemsInCartFreeGiftMessaging: {
    id: 'PromoBannerTracker.noItemsInCartFreeGiftMessaging',
    defaultMessage: 'Add ${remainingAmount} to earn a free {freeGiftName} with purchase.',
  },
  currentProgressInCartFreeGiftMessaging: {
    id: 'PromoBannerTracker.currentProgressInCartFreeGiftMessaging',
    defaultMessage: 'Spend ${remainingAmount} more to earn a free {freeGiftName} with purchase.',
  },
  fullyQualifiedInCartFreeGiftMessaging: {
    id: 'PromoBannerTracker.fullyQualifiedInCartFreeGiftMessaging',
    defaultMessage: 'Add your free {freeGiftName} to your cart.',
  },
  noItemsInBannerFreeGiftMessaging: {
    id: 'PromoBannerTracker.noItemsInBannerFreeGiftMessaging',
    defaultMessage: 'SPEND ${minimumSpendingAmount} & EARN A FREE GIFT',
  },
  currentProgressInBannerFreeGiftMessaging: {
    id: 'PromoBannerTracker.currentProgressInBannerFreeGiftMessaging',
    defaultMessage: 'SPEND ${remainingAmount} MORE & EARN A FREE GIFT',
  },
  fullyQualifiedInBannerFreeGiftMessaging: {
    id: 'PromoBannerTracker.fullyQualifiedInBannerFreeGiftMessaging',
    defaultMessage: 'CONGRATS! YOU EARNED A FREE GIFT',
  },
  noItemsInPDPFreeGiftMessaging: {
    id: 'PromoBannerTracker.noItemsInPDPFreeGiftMessaging',
    defaultMessage: 'Spend ${minimumSpendingAmount} to earn a free {freeGiftName} with purchase.',
  },
  currentProgressInPDPFreeGiftMessaging: {
    id: 'PromoBannerTracker.currentProgressInPDPFreeGiftMessaging',
    defaultMessage: 'Spend ${remainingAmount} more to earn a free {freeGiftName} with purchase.',
  },
  fullyQualifiedInPDPFreeGiftMessaging: {
    id: 'PromoBannerTracker.fullyQualifiedInPDPFreeGiftMessaging',
    defaultMessage: 'Congrats, you\'ve earned a free {freeGiftName} with purchase.',
  },
  freeGiftIconAlt: {
    id: 'PromoBannerTracker.freeGiftIconAlt',
    description: 'Alt for advertise icon',
    defaultMessage: 'Free Gift With Purchase',
  },
});
